import { Component, ChangeDetectionStrategy, input, output, computed } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { PolicyType, PolicyRole } from '@htx/policies';
import { CONSTRAINT_CATEGORIES, ConstraintCategory } from '../../shared/constraint-metadata';

@Component({
  selector: 'app-constraint-palette',
  imports: [MatIcon, TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './constraint-palette.component.html',
  styleUrl: './constraint-palette.component.scss'
})
export class ConstraintPaletteComponent {
  readonly disabledTypes = input<PolicyType[]>([]);
  readonly allowedRole = input<PolicyRole | undefined>(undefined);
  readonly typeSelected = output<PolicyType>();

  /** Filtered categories based on the allowed policy role. */
  readonly categories = computed<ConstraintCategory[]>(() => {
    const role = this.allowedRole();
    if (!role) return CONSTRAINT_CATEGORIES;

    return CONSTRAINT_CATEGORIES
      .map(cat => ({
        ...cat,
        types: cat.types.filter(t => t.allowedIn.includes(role))
      }))
      .filter(cat => cat.types.length > 0);
  });

  readonly hasAvailableTypes = computed(() => {
    const disabled = new Set(this.disabledTypes());
    return this.categories().some(cat =>
      cat.types.some(t => !disabled.has(t.type))
    );
  });

  isDisabled(type: PolicyType): boolean {
    return this.disabledTypes().includes(type);
  }

  select(type: PolicyType): void {
    if (!this.isDisabled(type)) {
      this.typeSelected.emit(type);
    }
  }
}
